import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import { SHIPPER_COLOR_LIST } from "../../../constants/constants";
import {
    Table,
} from "reactstrap";

function TableOveruseByShipper(props) {
    
    const shipperColor = [...SHIPPER_COLOR_LIST];
//   shipperColor.splice(0, 1)
    function numberFormat(number, digit = 2) {
        if (number === null || number === "null" || number === "") return "";
        function isFloat(n) {
            return Number(n) === n && n % 1 !== 0;
        }
        if (isFloat(number)) return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
            minimumFractionDigits: digit,
        });
        return parseFloat(number).toLocaleString(undefined, {
            minimumFractionDigits: digit,
        });
    }



    const renderSubColumn = () => {
        return props.shippers.map((shipper, shipperIndex) => {
            return (
                <React.Fragment key={shipperIndex.toString()}>
                    <th
                        style={{
                            backgroundColor: shipperColor[shipper.PRIORITY_FLAG],
                            color: "#FFFFFF",
                            textAlign: "center",
                            width: "20px",
                            fontSize: '10px'
                        }}
                    >
                        Booking
                    </th>
                    <th
                        style={{
                            backgroundColor:  shipperColor[shipper.PRIORITY_FLAG],
                            color: "#FFFFFF",
                            textAlign: "center",
                            width: "20px",
                            fontSize: '10px'
                        }}
                    >
                        Actual
                    </th>
                    <th
                        style={{
                            backgroundColor:  shipperColor[shipper.PRIORITY_FLAG],
                            color: "#FFFFFF",
                            textAlign: "center",
                            width: "20px",
                            fontSize: '10px'
                        }}
                    >
                        Overuse
                    </th>
                </React.Fragment>
            );
        });
    };


    return (
        <div className="table-responsive mb-3">
            <Table className="table table-bordered mb-0">
                <thead>
                    <tr>
                        <th
                            colSpan={(props.shippers.length * 3) + 1}
                            style={{
                                backgroundColor: "#556ee64a",
                                color: "#FFFFFF",
                                textAlign: "center",
                                width: "100%",
                            }}
                        >
                            Capacity Overuse
                        </th>
                    </tr>
                    <tr>
                        <th
                            rowSpan={2}
                            style={{
                                backgroundColor: "#556ee678",
                                color: "#FFFFFF",
                                textAlign: "center",
                            }}
                        >
                            Area
                        </th>
                        {props.shippers.map((shipper, shipperIndex) => {
                            return (
                                <th
                                    key={shipperIndex.toString()}
                                    colSpan={3}
                                    style={{
                                        backgroundColor:
                                        shipperColor[shipper.PRIORITY_FLAG],
                                        color: "#FFFFFF",
                                        textAlign: "center",
                                    }}
                                >
                                    {shipper.SHIPPER_NAME}
                                </th>
                            );
                        })}

                    </tr>
                    <tr>{renderSubColumn()}</tr>
                </thead>
                <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>
                    {Object.keys(props.overuseDataEntry).map((item,index) => {
                        return (
                            <tr key={index.toString()}>
                                <td>{item}</td>
                                {props.overuseDataEntry[item].sort((a, b) => (a.SHIPPER_PRIORITY_FLAG > b.SHIPPER_PRIORITY_FLAG) ? 1 : ((b.SHIPPER_PRIORITY_FLAG > a.SHIPPER_PRIORITY_FLAG) ? -1 : 0)).map((value,index) => {
                                    return (
                                        <React.Fragment key={index.toString()}>
                                            <td><p>{numberFormat(value.OVERUSE_BOOKING /1000, 0)}</p></td>
                                            <td><p>{numberFormat(value.OVERUSE_ACTUAL /1000, 0)}</p></td>
                                            <td style={{ ...(value.OVERUSE /1000).toFixed(0) > 0 && ({ color: '#FF4545' }) }}><p>{numberFormat(value.OVERUSE /1000, 0)}</p></td>
                                            {/* rgb(240, 20, 6) */}
                                        </React.Fragment>
                                    )
                                })}
                            </tr>
                        )

                    })}
                    <tr style={{ backgroundColor: "#556ee630" }}>
                        <td>Total</td>
                        {props.total.entry.sort((a, b) => (a.SHIPPER_PRIORITY_FLAG > b.SHIPPER_PRIORITY_FLAG) ? 1 : ((b.SHIPPER_PRIORITY_FLAG > a.SHIPPER_PRIORITY_FLAG) ? -1 : 0)).map((value, index) => {
                            return (
                                <React.Fragment key={index.toString()}>
                                    <td><p>{numberFormat(value.OVERUSE_BOOKING/1000 , 0)}</p></td>
                                    <td><p>{numberFormat(value.OVERUSE_ACTUAL/1000 , 0)}</p></td>
                                    <td style={{ ...(value.OVERUSE/1000 ).toFixed(0) > 0 && ({ color: '#FF4545' }) }}><p>{numberFormat(value.OVERUSE /1000, 0)}</p></td>
                                     {/* rgb(240, 20, 6) */}
                                </React.Fragment>
                            )
                        })}
                    </tr>
                    {Object.keys(props.overuseDataExit).map((item,index) => {
                        return (
                            <tr key={index.toString()}>
                                <td>{item}</td>
                                {props.overuseDataExit[item].sort((a, b) => (a.SHIPPER_PRIORITY_FLAG > b.SHIPPER_PRIORITY_FLAG) ? 1 : ((b.SHIPPER_PRIORITY_FLAG > a.SHIPPER_PRIORITY_FLAG) ? -1 : 0)).map((value,index) => {
                                    return (
                                        <React.Fragment key={index.toString()}>
                                            <td><p>{numberFormat(value.OVERUSE_BOOKING /1000, 0)}</p></td>
                                            <td><p>{numberFormat(value.OVERUSE_ACTUAL/1000, 0)}</p></td>
                                            <td style={{ ...(value.OVERUSE /1000).toFixed(0) > 0 && ({ color: '#FF4545' }) }}><p>{numberFormat(value.OVERUSE/1000, 0)}</p></td>
                                             {/* rgb(240, 20, 6) */}
                                        </React.Fragment>
                                    )
                                })}
                            </tr>
                        )

                    })}
                    <tr style={{ backgroundColor: "#556ee630" }}>
                        <td>Total</td>
                        {props.total.exit.sort((a, b) => (a.SHIPPER_PRIORITY_FLAG > b.SHIPPER_PRIORITY_FLAG) ? 1 : ((b.SHIPPER_PRIORITY_FLAG > a.SHIPPER_PRIORITY_FLAG) ? -1 : 0)).map((value, index) => {
                            return (<React.Fragment key={index.toString()}>
                                <td><p>{numberFormat(value.OVERUSE_BOOKING/1000 , 0)}</p></td>
                                <td><p>{numberFormat(value.OVERUSE_ACTUAL /1000, 0)}</p></td>
                                <td style={{ ...(value.OVERUSE/1000 ).toFixed(0) > 0 && ({ color: '#FF4545' }) }}><p>{numberFormat(value.OVERUSE/1000 , 0)}</p></td>
                                 {/* rgb(240, 20, 6) */}
                            </React.Fragment>)
                        })}
                    </tr>
                </tbody>

            </Table>
        </div>





    );
}

TableOveruseByShipper.propTypes = {
    // t: PropTypes.any,
    shippers: PropTypes.any,
    overuseDataEntry: PropTypes.any,
    overuseDataExit: PropTypes.any,
   total: PropTypes.any,
};

export default TableOveruseByShipper;
